module.exports = __webpack_public_path__ + "af89c27f3fcb4864f1b3b5c613c9a612.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/backoffice/no-transaction.png
// module id = 1020
// module chunks = 0